import { LAYOUTS } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { WIDGET } from "@voltmoney/schema";
import { getKFSDataBajaj, getLenderInfo } from "../../configs/utils";
import { ACTION } from "./types";
import { agreeAction, goBackAction, needHelpAction, successCardAction } from "./actions";
export const template = async (height, lenderInfo, kfsData) => {
    return {
        layout: {
            id: ROUTE.BAJAJ_KFS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "bajajKFS", type: WIDGET.BAJAJ_KFS }
            ],
        },
        datastore: {
            bajajKFS: {
                height: height,
                kfs_data: kfsData,
                lenderData: lenderInfo,
                needHelp: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.BAJAJ_KFS,
                    payload: {}
                },
                goBack: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.BAJAJ_KFS,
                    payload: {}
                },
                agreeAction: {
                    type: ACTION.AGREE,
                    routeId: ROUTE.BAJAJ_KFS,
                    payload: {}
                },
                successCardAction: {
                    type: ACTION.SUCCESS_CARD_ACTION,
                    routeId: ROUTE.BAJAJ_KFS,
                    payload: {}
                }
            }
        },
    };
};
export const bajajKFSMf = {
    onLoad: async ({ network, getHeight, removeWidgets }) => {
        await removeWidgets(ROUTE.BAJAJ_KFS, [
            { id: "bajajKFS", type: WIDGET.BAJAJ_KFS }
        ]);
        const lenderInfo = await getLenderInfo(network);
        const kfsData = await getKFSDataBajaj(network);
        return Promise.resolve(template(getHeight(), lenderInfo, kfsData));
    },
    actions: {
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.AGREE]: agreeAction,
        [ACTION.SUCCESS_CARD_ACTION]: successCardAction
    },
    clearPrevious: true,
};
